(() => {
  const initializeHeader = () => {
    const shell = document.querySelector('[data-aparthy-header-shell]');
    if (!shell || shell.dataset.aparthyHeaderReady === 'true') return;
    shell.dataset.aparthyHeaderReady = 'true';

    const toggle = shell.querySelector('[data-aparthy-menu-toggle]');
    const menu = shell.querySelector('[data-aparthy-mobile-menu]');
    const closeButtons = shell.querySelectorAll('[data-aparthy-menu-close]');

    const setOpen = (open) => {
      shell.classList.toggle('is-menu-open', open);
      toggle?.setAttribute('aria-expanded', String(open));
      menu?.setAttribute('aria-hidden', String(!open));
      document.documentElement.classList.toggle('aparthy-menu-open', open);
      if (open) menu?.querySelector('a')?.focus({ preventScroll: true });
      else toggle?.focus({ preventScroll: true });
    };

    toggle?.addEventListener('click', () => setOpen(!shell.classList.contains('is-menu-open')));
    closeButtons.forEach((button) => button.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && shell.classList.contains('is-menu-open')) setOpen(false);
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
      if (event.matches) setOpen(false);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeHeader, { once: true });
  else initializeHeader();
  document.addEventListener('shopify:section:load', initializeHeader);
})();
